import { createActionCreator } from '@pressreader/appstore';
import type { IArticle } from '@pressreader/content-types';

import { MODULE_NAME } from '../../constants';

const prefix = `${MODULE_NAME}/common/`;

export const openCopyArticleDialogAction = createActionCreator<{
    article: IArticle;
}>(`${prefix}open-copy-article-dialog-action`);
